import {BaseDao} from "./BaseDao";
import {Observable} from "rxjs";
import { PostlogProvider } from "../../models/postlogProvider";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";

export class PostlogProviderDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.POSTLOGPROVIDERS, apiHelper);
    }
}